"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sprintf_js_1 = require("sprintf-js");
exports.translate = translations => (key, parameters) => {
    const translated = translations && key in translations ? translations[key] : key;
    try {
        return sprintf_js_1.vsprintf(translated, parameters);
    }
    catch (e) {
        return translated.replace(/%s|%d/gi, '');
    }
};
//# sourceMappingURL=translate.js.map